var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('create-macro-columns',{attrs:{"template":_vm.template,"categories":_vm.categories},on:{"delete-column-chip":_vm.deleteColumnChip}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }